let getCustomInboxEmail;
export function setCustomInboxEmail(onGetCustomInboxEmail) {
    getCustomInboxEmail = onGetCustomInboxEmail;
}
/**
 * getInboxEmail uses account data GetResponse<AccountData, AccountColumns>
 * to get email address for 'inbox' channel.
 * If the ContactManagementConfig setCustomInboxEmail function is not provided,
 * it takes data from account.columns.email.
 * This function must be used when specifying inbox channel recipients in other libraries.
 */
export function getInboxEmail(appContext, account) {
    return getCustomInboxEmail ? getCustomInboxEmail(appContext, account) : account.columns.email;
}
